module.exports = __webpack_public_path__ + "img/6.754c8138.jpg";